import { render, staticRenderFns } from "./News.vue?vue&type=template&id=7c43b1ca&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=7c43b1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43b1ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticlePreviewCard: require('/app/components/article/ArticlePreviewCard.vue').default})
